import React from 'react';
import './AdminCSS/deviceupdate.css';

const DeviceUpdate = ({ formData, setFormData, handleUpdateSubmit, setSelectedDevice }) => {
  return (
    <div className="popup-device">
      <h3>Update Device</h3>
      <label htmlFor="email">User Email:</label>
      <input
        type="email"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        placeholder="User email"
        required
      />
      <label htmlFor="mac_address">MAC Address:</label>
      <input
        type="text"
        value={formData.mac_address}
        onChange={(e) => setFormData({ ...formData, mac_address: e.target.value })}
        placeholder="MAC Address"
        required
      />
      <button onClick={handleUpdateSubmit}>Submit</button>
      <button onClick={() => setSelectedDevice(null)}>Cancel</button>
    </div>
  );
};

export default DeviceUpdate;
